// Module
var code = "<template> <div class=\"ess-grid\"> <div class=\"ess-col s12 m11\"> <ess-text value.bind=\"fileDisplayName\" required=\"true\" label=\"${'core:document.file.name.$' | t}\" maxlength.bind=\"maxlength\"></ess-text> </div> <div class=\"ess-col s12 m1\" style=\"padding-top:1.5em\"> .${fileExtension} </div> </div> </template> ";
// Exports
module.exports = code;